import React, { Component } from 'react';
import Card from 'antd/es/card/Card';
import Text from 'antd/es/typography/Text';
import Title from 'antd/es/typography/Title';
import { Button, Table, TablePaginationConfig } from 'antd';
import dayjs from 'dayjs';
import { ITransferItem, TransactionStatusEnum } from '../store';
import { BaseType } from 'antd/es/typography/Base';
// import { ReactComponent as Pay1 } from '../assets/pay-1.svg';
// import { ReactComponent as Pay2 } from '../assets/pay-2.svg';
// import { ReactComponent as Pay3 } from '../assets/pay-3.svg';
import { ReactComponent as Pay4 } from '../assets/pay-4.svg';
import { ReactComponent as Pay5 } from '../assets/pay-5.svg';
import { ReactComponent as Pay6 } from '../assets/pay-6.svg';
import { ReactComponent as Pay7 } from '../assets/pay-7.svg';
import { ReactComponent as Pay8 } from '../assets/pay-8.svg';
// import { ReactComponent as Pay9 } from '../assets/pay-9.svg';
import { ReactComponent as Pay10 } from '../assets/pay-10.svg';
import { FilterValue, SorterResult, TableCurrentDataSource } from 'antd/es/table/interface';

const statusMap = {
  [TransactionStatusEnum.CREATED]: { text: 'Создана', type: 'secondary' },
  [TransactionStatusEnum.COMPLETED]: { text: 'Проведена', type: 'success' },
  [TransactionStatusEnum.FAILED]: { text: 'Неудачно', type: 'danger' },
  [TransactionStatusEnum.CANCELED]: { text: 'Отменена', type: 'warning' },
};

const payIcons = [
  // { id: '1', icon: <Pay1 /> },
  // { id: '2', icon: <Pay2 /> },
  // { id: '3', icon: <Pay3 /> },
  { id: '4', icon: <Pay4 /> },
  { id: '5', icon: <Pay5 /> },
  { id: '6', icon: <Pay6 /> },
  { id: '7', icon: <Pay7 /> },
  { id: '8', icon: <Pay8 /> },
  // { id: '9', icon: <Pay9 /> },
  { id: '10', icon: <Pay10 /> },
];

interface IProps {
  title: string;
  tableTitle: string;
  list: ITransferItem[];
  total: number;
  limit: number;
  children?: React.ReactNode;
  changeWitdrawalTransfer?(id: string): void;
  handleTableChange(
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<ITransferItem> | SorterResult<ITransferItem>[],
    extra: TableCurrentDataSource,
  ): void;
}

class _TransfersBalance extends Component<IProps> {
  render() {
    const { title, list, tableTitle, handleTableChange, total, limit, children, changeWitdrawalTransfer } = this.props;
    const columns = [
      {
        title: 'ID',
        dataIndex: 'transactionId',
        key: 'transactionId',
        render: (id: string) => (
          <Text ellipsis={{ tooltip: id }} style={{ maxWidth: 50 }}>
            {id}
          </Text>
        ),
      },
      { title: 'Сумма', dataIndex: 'amount', key: 'amount', sorter: true },
      {
        title: 'Дата создания',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (time: string) => <Text>{time ? dayjs(time).format('DD.MM.YY HH:mm:ss') : ''}</Text>,
      },
      {
        title: 'Состояние',
        dataIndex: 'status',
        key: 'status',
        sorter: false,
        render: (status: TransactionStatusEnum, item: ITransferItem) => {
          const { text, type } = statusMap[status];

          return (
            <>
              <Text type={type as BaseType}>{text}</Text>
              {status === TransactionStatusEnum.CREATED && (
                <Button style={{ marginLeft: 20 }} onClick={() => changeWitdrawalTransfer?.(item.transactionId)}>
                  Отменить
                </Button>
              )}
            </>
          );
        },
      },
    ];

    return (
      <Card bordered={false} title={title} style={{ marginBottom: 8 }}>
        {children}
        <Title level={4}>
          Для пополнения или вывода средств свяжитесь с{' '}
          <a href="https://t.me/relaxtimeadmin" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5 }}>
            @relaxtimeadmin
          </a>{' '}
          в Telegram
        </Title>
        <Text type="secondary">{'В процессе подключения:'}</Text>
        <br />
        {payIcons.map(i =>
          React.cloneElement(i.icon, {
            key: i.id,
            style: { height: 50, width: 50, marginRight: 20 },
          }),
        )}
        <Title level={5}>{tableTitle}</Title>
        <Table
          dataSource={list}
          columns={columns}
          pagination={{ total: total, pageSize: limit }}
          onChange={handleTableChange}
        />
      </Card>
    );
  }
}

export const TransfersBalance = _TransfersBalance;
